import React from 'react';
import { WindowsDirectionSearchOffersEnum } from '@search/graphql-typings';
import { Checkbox } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';

import { WindowsDirectionFilter } from '../../../models/Filter';

interface IWindowDirectionNewFilter {
    filter: WindowsDirectionFilter;
    handleChange: (value: WindowsDirectionFilter) => void;
    classNameGroup?: string;
}

const OPTIONS: OptionType<WindowsDirectionSearchOffersEnum>[] = [
    { label: 'Во двор', value: WindowsDirectionSearchOffersEnum.Rear },
    { label: 'На улицу', value: WindowsDirectionSearchOffersEnum.Front },

];

export const WindowDirectionNewFilter: React.FC<IWindowDirectionNewFilter> = ({
    filter,
    handleChange,
    classNameGroup
}) => {
    const onChange = React.useCallback((value: boolean, optionType: WindowsDirectionSearchOffersEnum) => {
        const filters = new Set(filter.value);

        filters[value ? 'add' : 'delete'](optionType);
        handleChange(new WindowsDirectionFilter(Array.from(filters)));
    }, [ handleChange, filter.value ]);

    return (
        <div className={classNameGroup}>
            {OPTIONS.map(({ label, value }) => (
                <div key={value} style={{ width: 'max-content' }}>
                    <Checkbox
                        name={label}
                        value={filter.value.includes(value)}
                        onChange={v => onChange(v, value)}
                        variant='filter'
                        dataTest='window-direction'
                        block
                    >
                        {label}
                    </Checkbox>
                </div>
            ))}
        </div>
    );
};
